import { MessageService, type Chat, type Message } from '@/shared/api';
import { useFetchComposable } from '@/shared/lib';

const useMessageDelete = () => {
  const { send: deleteMessage } = useFetchComposable(
    ({
      chatId,
      messageId,
      forEveryone,
    }: {
      chatId: Chat['id'];
      messageId: Message['id'];
      forEveryone: boolean;
    }) => MessageService.deleteMessage({ path: { id: chatId, messageId }, query: { forEveryone } }),
  );

  return { deleteMessage };
};

export { useMessageDelete };
